import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useMeasure } from 'react-use';
import useEvents from 'lib/hooks/useEvents';
import tapEvent from 'lib/Tracking/Vdp/WarrantyPromo/TapEvent';
import VdpEventContext from 'contexts/VdpEventContext';
import {
  verticalStyles,
  sharedStyles,
  horizontalStyles,
} from 'components/Article/content/WarrantyPromo/styles';

export const warrantyLink =
  'https://www.consumeraffairstrk.com/DFBHL/2CTPL/?sub1=areworthit&sub5=UNIQUETRANSACTIONID';

// svg for for arrow-effect overlaying the right side of the car image
const imageMask = `data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 25.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 45.7 86.2' style='enable-background:new 0 0 45.7 86.2;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D%0A%3C/style%3E%3Cpath class='st0' d='M0,0.1l37.2,37.2c3.2,3.2,3.2,8.3,0,11.5L0,86.1h45.7v-86H0z'/%3E%3C/svg%3E%0A`;

export const breakpoint = 500;

const WarrantyPromo = (): JSX.Element => {
  const { t } = useTranslation();
  const logger = useEvents();
  const { trackingParams } = useContext(VdpEventContext);
  const [ref, { width }] = useMeasure<HTMLDivElement>();
  const isWide = !!(width && width > breakpoint);
  const orientationStyles = isWide ? horizontalStyles : verticalStyles;

  return (
    <div ref={ref} data-testid="warranty-promo-container">
      <a
        data-testid="warranty-promo-hyperlink"
        href={warrantyLink}
        target="_blank"
        aria-label={t('accessibility.newWindow')}
        onClick={(): void => {
          logger.log(tapEvent({ trackingParams }));
        }}
      >
        <div className="warranty-promo">
          <div className="warranty-promo-image">
            <div
              className="warranty-promo-image-mask"
              style={{ background: `url("${imageMask}")` }}
            />
          </div>
          <div className="warranty-promo-body">
            <div className="warranty-promo-text-region">
              <div className="warranty-promo-text desktop">{t('article.warrantyPromoText')}</div>
              <div className="warranty-promo-subtext">{t('article.warrantyPromoSubtext')}</div>
            </div>
            <div className="warranty-promo-cta">{t('article.warrantyCta')}</div>
          </div>
        </div>
        <style jsx>{sharedStyles}</style>
        <style jsx>{orientationStyles}</style>
      </a>
    </div>
  );
};

export default WarrantyPromo;
